'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _fetchPropertyNoteById = require('../../utils/fetchPropertyNoteById');var _fetchPropertyNoteById2 = _interopRequireDefault(_fetchPropertyNoteById);

var _FullScreenPropertiesList = require('./FullScreenPropertiesList.scss');var styles = _interopRequireWildcard(_FullScreenPropertiesList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// Styles
var FullScreenPropertiesList = function (_Component) {_inherits(FullScreenPropertiesList, _Component);function FullScreenPropertiesList() {var _temp, _this, _ret;_classCallCheck(this, FullScreenPropertiesList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderFullScreenPropertyList = function () {var _this$props =















      _this.props,locale = _this$props.locale,isRtl = _this$props.isRtl,translate = _this$props.translate,isPreview = _this$props.isPreview,favoriteIDs = _this$props.favoriteIDs,propertyNotes = _this$props.propertyNotes,toggleFavorite = _this$props.toggleFavorite,addPropertyNote = _this$props.addPropertyNote,openDetailsPopup = _this$props.openDetailsPopup,isFavoritesList = _this$props.isFavoritesList,loading = _this$props.loading,loaded = _this$props.loaded,properties = _this$props.properties,favoritesData = _this$props.favoritesData;

      if (properties && properties.length || favoritesData && favoritesData.length) {
        var propertiesArray = _this.props.isFavoritesList ?
        favoritesData || [] :
        properties || [];

        return propertiesArray.map(function (item) {
          var isFavorite = favoriteIDs.indexOf(item.id) !== -1;
          var propertyNote = (0, _fetchPropertyNoteById2.default)(item.id, propertyNotes);

          return (
            _react2.default.createElement('div', { key: item.id },
              _react2.default.createElement(_components.FullScreenPropertyCell, {
                property: item,
                locale: locale,
                isRtl: isRtl,
                translate: translate,
                isPreview: isPreview,
                isFavorite: isFavorite,
                propertyNote: propertyNote,
                toggleFavorite: toggleFavorite,
                addPropertyNote: addPropertyNote,
                openDetailsPopup: openDetailsPopup })));



        });
      } else if (loading === false && loaded) {
        return isFavoritesList ? _this.renderFavoritesNoResults() : _this.renderNoResults();
      }
      return _react2.default.createElement('div', { className: styles.spinnerPosition }, _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }));
    }, _this.

    renderNoResults = function () {return _react2.default.createElement('div', null, 'No Results');}, _this.

    renderFavoritesNoResults = function () {return _react2.default.createElement('div', null, 'No Favorites');}, _temp), _possibleConstructorReturn(_this, _ret);}FullScreenPropertiesList.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.fullScreenPropertiesList },
        this.renderFullScreenPropertyList()));


  };return FullScreenPropertiesList;}(_react.Component);


FullScreenPropertiesList.propTypes = {
  properties: _propTypes2.default.array,
  favoritesData: _propTypes2.default.array,
  isFavoritesList: _propTypes2.default.bool,
  favoriteIDs: _propTypes2.default.array,
  isRtl: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  loaded: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isPreview: _propTypes2.default.bool,
  propertyNotes: _propTypes2.default.array,
  toggleFavorite: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
    loading: state.propertySearch.loading,
    loaded: state.propertySearch.loaded,
    properties: state.propertySearch.data,
    favoriteProperties: state.favoriteProperties,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    favoritesData: state.favoriteProperties.favoritesData,
    favoriteIDs: state.favoriteProperties.favoriteIDs,
    isFavoritesList: state.favoriteProperties.favoritesListIsActive,
    locale: state.lang.locale,
    isPreview: state.propertyDetails.isPreview,
    propertyNotes: state.propertyNotes.data,
    propertiesCount: state.propertySearch.propertiesCount,
    skip: state.propertySearch.skip };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(FullScreenPropertiesList);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FullScreenPropertiesList/FullScreenPropertiesList.js
// module id = 2938
// module chunks = 0